import { render } from "./AppXNoticeBox.vue?vue&type=template&id=78a9b252&scoped=true&ts=true"
import script from "./AppXNoticeBox.vue?vue&type=script&lang=ts"
export * from "./AppXNoticeBox.vue?vue&type=script&lang=ts"

import "./AppXNoticeBox.vue?vue&type=style&index=0&id=78a9b252&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a9b252"]])

export default __exports__